<template>
  <div class="error-illustration">

    <div class="error-illustration__text">
      <h3 class="error-illustration__title">{{title}}</h3>
      <div class="error-illustration__description">{{description}}</div>
      <c-button theme="primary" size="sm" @click="refresh">Refresh page</c-button>
    </div>
    <ErrorIllustration/>
  </div>
</template>

<style lang="scss">
  .error-illustration{
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    text-align: center;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;

    }

    svg{
      max-width: 100%;
    }

    &__text{
      min-width: 300px;
    }

    &__title{
      font-size: 21px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    &__description{
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
</style>

<script>
import ErrorIllustration from "../illustration/error-illustration";

export default {
  components: {ErrorIllustration},
  props:['title', 'description'],
  methods:{
    refresh(){
      window.location.reload()
    }
  }
}
</script>